import { useCallback, useState } from 'react';
import { useDataProvider } from 'react-admin';

export interface BatchAssignToChannelSkipped {
  serial: string;
  reason: string;
  hardware_name?: string;
  hardware_revision_name?: string;
}

export interface BatchAssignToChannelResult {
  updated: string[];
  skipped: BatchAssignToChannelSkipped[];
  not_found: string[];
}

export interface UseBatchAssignUnitsToChannel {
  batchAssign: (channelId: number, payload: string[] | File) => Promise<BatchAssignToChannelResult>;
  loading: boolean;
}

export function useBatchAssignUnitsToChannel(): UseBatchAssignUnitsToChannel {
  const dataProvider = useDataProvider();
  const [loading, setLoading] = useState(false);

  const batchAssign = useCallback(
    async (channelId: number, payload: string[] | File): Promise<BatchAssignToChannelResult> => {
      const endpoint = `update_channels/${channelId}/batch-assign-units`;

      let body: FormData | { serials: string[] };
      if (payload instanceof File) {
        const formData = new FormData();
        formData.append('file', payload);
        body = formData;
      } else {
        body = { serials: payload };
      }

      setLoading(true);
      try {
        const res = await dataProvider.post(endpoint, body);
        const updated: string[] = res?.updated ?? [];
        const skipped: BatchAssignToChannelSkipped[] = res?.skipped ?? [];
        const not_found: string[] = res?.not_found ?? [];
        return { updated, skipped, not_found };
      } finally {
        setLoading(false);
      }
    },
    [dataProvider],
  );

  return { batchAssign, loading };
}
